module.exports = {
    ADD_SUSCRIPTION_ERROR : 'ADD_SUSCRIPTION_ERROR',
    HIRE_INVESTMENT_FUND_ERROR : 'HIRE_INVESTMENT_FUND_ERROR',
}
